/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/gateways';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "VerificationRequest": {
                "nested": {
                  "CardOnFileUse": {
                    "values": {
                      "NONE": 0,
                      "CARDHOLDER_INITIATED": 1,
                      "RECURRING": 2
                    }
                  }
                }
              },
              "AvsVerificationResult": {
                "values": {
                  "AVS_RESULT_DEAULT_DO_NOT_USE": 0,
                  "AVS_PRESENT_BUT_NOT_CHECKED": 1,
                  "AVS_ABSENT": 2,
                  "AVS_PRESENT_AND_REJECTED": 3,
                  "AVS_PRESENT_AND_ACCEPTED": 4
                }
              },
              "CvvVerificationResult": {
                "values": {
                  "CVV_RESULT_DEAULT_DO_NOT_USE": 0,
                  "CVV_PRESENT_BUT_NOT_CHECKED": 1,
                  "CVV_ABSENT": 2,
                  "CVV_PRESENT_AND_REJECTED": 3,
                  "CVV_PRESENT_AND_ACCEPTED": 4
                }
              },
              "AccountVerificationResult": {
                "values": {
                  "ACCOUNT_RESULT_DEFAULT_DO_NOT_USE": 0,
                  "ACCOUNT_VALID": 1,
                  "ACCOUNT_FAILURE_INVALID_EXPIRATION_FORMAT": 2,
                  "ACCOUNT_FAILURE_EXPIRED": 3,
                  "ACCOUNT_FAILURE_BLACKLISTED": 4,
                  "ACCOUNT_FAILURE_INVALID": 5,
                  "ACCOUNT_FAILURE_OTHER": 6,
                  "ACCOUNT_FAILURE_NOT_SUPPORTED": 7,
                  "ACCOUNT_FAILURE_SHADOWBAN": 8,
                  "ACCOUNT_FAILURE_PAN_BLOCKED_BY_MERCHANT": 9,
                  "ACCOUNT_FAILURE_CLIENT_IP_BLOCKED_BY_RISK": 10,
                  "ACCOUNT_FAILURE_BROWSER_FINGERPRINT_BLOCKED_BY_RISK": 11,
                  "ACCOUNT_SOFT_FAILURE_AUTHENTICATION_REQUIRED": 12,
                  "ACCOUNT_FAILURE_BLOCKED_BY_DECLINE_RATE_LIMIT": 13,
                  "ACCOUNT_FAILURE_CARD_BLOCKED_BY_RISK": 14,
                  "ACCOUNT_FAILURE_EMAIL_BLOCKED_BY_RISK": 15,
                  "ACCOUNT_FAILURE_PAN_BLOCKED_BY_RISK": 16,
                  "ACCOUNT_FAILURE_BLOCKED_BY_TRAFFIC_REMEDIATION": 17,
                  "ACCOUNT_FAILURE_BIN_BLOCKED_BY_RISK": 18,
                  "ACCOUNT_FAILURE_AVT_BLOCKED_BY_RISK": 19,
                  "ACCOUNT_FAILURE_JA3_BLOCKED_BY_RISK": 20
                }
              },
              "VerificationDebuggingInfo": {
                "fields": {
                  "gatewayName": {
                    "type": ".squareup.common.gateways.GatewayName",
                    "id": 1,
                    "rule": "optional"
                  },
                  "reason": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "paymentId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "avsResponse": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "cvvResponse": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "VerificationResponse": {
                "nested": {
                  "CardCapability": {
                    "values": {
                      "DEFAULT_CAP_DO_NOT_USE": 0,
                      "SUPPORTS_INSTANT_PUSH": 1
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.VerificationRequest?.nested?.CardOnFileUse && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.AvsVerificationResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.CvvVerificationResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.AccountVerificationResult && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.VerificationDebuggingInfo && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.VerificationResponse?.nested?.CardCapability) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE VerificationRequest @ squareup/esperanto/api/verify.proto at 19:1
 */
export const VerificationRequest = {};
/**
 * SOURCE CardOnFileUse @ squareup/esperanto/api/verify.proto at 27:3
 */
VerificationRequest.CardOnFileUse = $root.lookupEnum('squareup.esperanto.api.VerificationRequest.CardOnFileUse').values;
/**
 * SOURCE AvsVerificationResult @ squareup/esperanto/api/verify.proto at 166:1
 */
export const AvsVerificationResult = $root.lookupEnum('squareup.esperanto.api.AvsVerificationResult').values;
/**
 * SOURCE CvvVerificationResult @ squareup/esperanto/api/verify.proto at 191:1
 */
export const CvvVerificationResult = $root.lookupEnum('squareup.esperanto.api.CvvVerificationResult').values;
/**
 * SOURCE AccountVerificationResult @ squareup/esperanto/api/verify.proto at 216:1
 */
export const AccountVerificationResult = $root.lookupEnum('squareup.esperanto.api.AccountVerificationResult').values;
/**
 * Information to assist in debugging verification results. This is only intended to aid in human
 * debugging and data analysis. If you're using these values in code, you're probably doing
 * something wrong.
 *
 * SOURCE VerificationDebuggingInfo @ squareup/esperanto/api/verify.proto at 344:1
 */
export const VerificationDebuggingInfo = $root.lookupType('squareup.esperanto.api.VerificationDebuggingInfo');
fixType(VerificationDebuggingInfo);
Builder.createAndAttachToType(VerificationDebuggingInfo);
/**
 * SOURCE VerificationResponse @ squareup/esperanto/api/verify.proto at 365:1
 */
export const VerificationResponse = {};
/**
 * SOURCE CardCapability @ squareup/esperanto/api/verify.proto at 411:3
 */
VerificationResponse.CardCapability = $root.lookupEnum('squareup.esperanto.api.VerificationResponse.CardCapability').values;